import axiosClient from './axiosClient';

export interface SuggestionItem {
  dimension: string;
  severity: 'high' | 'medium' | 'low';
  suggestion: string;
}

export interface ProposalAnalysisDto {
  id: string;
  opportunityId: string;
  status: 'PENDING' | 'RUNNING' | 'COMPLETED' | 'FAILED';
  overallScore?: number;
  complianceScore?: number;
  keywordScore?: number;
  technicalTermsScore?: number;
  grammarScore?: number;
  punctuationScore?: number;
  structureScore?: number;
  flowScore?: number;
  wordCountScore?: number;
  candidateFitScore?: number;
  selectionProbabilityScore?: number;
  passThreshold: number;
  passed?: boolean;
  summary?: string;
  suggestions?: SuggestionItem[];
  dimensionDetails?: Record<string, unknown>;
  errorMessage?: string;
  modelUsed?: string;
  tokensUsed?: number;
  triggeredByName?: string;
  startedAt?: string;
  completedAt?: string;
  createdAt?: string;
}

export const analysisApi = {
  trigger: (opportunityId: string) =>
    axiosClient.post<ProposalAnalysisDto>(`/opportunities/${opportunityId}/analysis`),

  getLatest: (opportunityId: string) =>
    axiosClient.get<ProposalAnalysisDto>(`/opportunities/${opportunityId}/analysis/latest`),

  getById: (opportunityId: string, analysisId: string) =>
    axiosClient.get<ProposalAnalysisDto>(
      `/opportunities/${opportunityId}/analysis/${analysisId}`,
    ),

  getAll: (opportunityId: string) =>
    axiosClient.get<ProposalAnalysisDto[]>(`/opportunities/${opportunityId}/analysis/all`),

  reExtractRequirements: (opportunityId: string) =>
    axiosClient.post(`/opportunities/${opportunityId}/analysis/re-extract-rfo-requirements`),
};
